import React, { useContext, useState } from "react";
import "./SectionCard.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { faEllipsisVertical } from "@fortawesome/pro-regular-svg-icons";
import MDSpinner from "react-md-spinner";
import formatDateString from "../../../Util/functions/FormatDateString";
import getIconFromCategoryString from "../../../Util/functions/getIconFromCategoryString";
import { AppContext } from "../../../Util/contexts/AppContext";
import { createPortal } from "react-dom";
import ButtonListPopup from "../../../Components/ButtonListPopup/ButtonListPopup";
import { getClientTimezoneName } from "../../../Util/functions/TimeZone";
export default function SectionCard({
  sectionData,
  isSectionSelected,
  handleSectionClick,
  forceEllipses,
}) {
  const {
    userData,
    primaryColor,
    handleViewPreviousSectionCompletions,
    mousePosition,
    fetchMarkReviewLater,
    reviewLaterSections,
  } = useContext(AppContext);
  const [fetchingReviewLater, setFetchingReviewLater] = useState(false);
  const [showMoreSectionOptions, setShowMoreSectionOptions] = useState(false);

  const {
    sectionId,
    sectionNumber,
    sectionTitle,
    sectionCategory,
    Completed,
    LastCompletionDate,
    secCompletion,
  } = sectionData;

  const handleReviewLaterClick = async (e) => {
    e.stopPropagation();
    setFetchingReviewLater(true);
    const newValue = reviewLaterSections[sectionId] ? false : true;
    await fetchMarkReviewLater(null, sectionId, newValue);
    setFetchingReviewLater(false);
  };

  const handleViewGrades = (e) => {
    e.stopPropagation();
    setShowMoreSectionOptions(false);
    console.log(secCompletion);
    handleViewPreviousSectionCompletions({
      sectionId,
    });
  };

  const isSectionCompletedAndValid = Completed && secCompletion.length !== 0;

  return (
    <div
      id={`section-${sectionId}`}
      className={`caseListSectionContainer${
        isSectionSelected ? " caseListCaseSelected" : ""
      }`}
      key={"section - " + sectionTitle + " - " + sectionId}
    >
      <div
        className={`caseListSectionCheckboxWrapper ${
          isSectionSelected ? "caseListSectionCheckboxSelected" : ""
        }`}
        onClick={() => handleSectionClick(sectionData)}
      >
        <button className="caseListSectionCheckbox">
          {isSectionSelected && (
            <FontAwesomeIcon
              icon={faCheck}
              className="caseListSectionCheckboxIcon"
            />
          )}
        </button>
      </div>
      <div
        className="caseListSectionContentWrapper"
        style={
          forceEllipses
            ? { gridTemplateColumns: "1fr", marginRight: "30px" }
            : {}
        }
        onClick={() => handleSectionClick(sectionData)}
      >
        <div
          className="caseListSectionDetailsWrapper"
          style={{ rowGap: isSectionCompletedAndValid ? 2 : 5 }}
        >
          <FontAwesomeIcon
            icon={getIconFromCategoryString(sectionCategory)}
            className="caseListSectionDetailsIcon"
          />
          <h3 className="caseListSectionDetailsTitle">{sectionTitle}</h3>
          <p className="caseListSectionDetailsSubtitle">
            {`Section ${sectionNumber} | Section Id ${sectionId}`}
          </p>
        </div>
        {isSectionCompletedAndValid && (
          <p className="caseListSectionCompletionText">
            Completed:{" "}
            {formatDateString(
              LastCompletionDate,
              userData.TimeZoneOverride
                ? getClientTimezoneName()
                : userData.TimeZone
            )}{" "}
            (
            {Math.floor(
              secCompletion[secCompletion.length - 1]?.GradeForExam * 100
            ) / 100}
            %)
          </p>
        )}
        {isSectionCompletedAndValid && !forceEllipses && (
          <button
            className="caseListSectionViewGradesButton"
            onClick={handleViewGrades}
          >
            View Grades
          </button>
        )}
        {!forceEllipses && (
          <button
            className="caseListSectionReviewLaterButton"
            onClick={handleReviewLaterClick}
          >
            <div className="caseListSectionReviewLaterCheckboxWrapper">
              {fetchingReviewLater ? (
                <MDSpinner size={15} singleColor={primaryColor} />
              ) : (
                <div className="caseListSectionReviewLaterCheckbox">
                  {reviewLaterSections[sectionId] && (
                    <FontAwesomeIcon
                      icon={faCheck}
                      className="caseListSectionReviewLaterCheckboxIcon"
                    />
                  )}
                </div>
              )}
            </div>
            Review Later
          </button>
        )}
      </div>
      <button
        className="caseListSectionMobileMoreOptionsButton"
        style={forceEllipses ? { display: "initial" } : {}}
        onClick={(e) => {
          setShowMoreSectionOptions(!showMoreSectionOptions);
        }}
      >
        <FontAwesomeIcon
          icon={faEllipsisVertical}
          className="caseListSectionMobileMoreOptionsIcon"
        />
      </button>
      {showMoreSectionOptions &&
        createPortal(
          <ButtonListPopup
            showButtonListPopup={showMoreSectionOptions}
            setShowButtonListPopup={setShowMoreSectionOptions}
            mousePos={mousePosition}
            key={`sectionMoreOptionsPopup - ${sectionId}`}
            childKey={`sectionMoreOptionsPopupChild - ${sectionId}`}
          >
            {isSectionCompletedAndValid && (
              <button
                className="moreOptionsPopupButton"
                onClick={handleViewGrades}
              >
                View Grades
              </button>
            )}
            <button
              className="moreOptionsPopupReviewLaterButton"
              onClick={handleReviewLaterClick}
            >
              <div className="caseListSectionReviewLaterCheckboxWrapper">
                {fetchingReviewLater ? (
                  <MDSpinner size={15} singleColor={primaryColor} />
                ) : (
                  <div className="caseListSectionReviewLaterCheckbox">
                    {reviewLaterSections[sectionId] && (
                      <FontAwesomeIcon
                        icon={faCheck}
                        className="caseListSectionReviewLaterCheckboxIcon"
                      />
                    )}
                  </div>
                )}
              </div>
              Review Later
            </button>
          </ButtonListPopup>,
          document.body
        )}
    </div>
  );
}
